"use client";

import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth/auth-context";

/**
 * Gates the signed-in console.
 *
 * This is a convenience, NOT a security boundary, and the distinction is worth
 * stating where someone might mistake it: every request is authorised at the
 * gateway against a token this client cannot forge. Removing this component
 * would expose empty screens, not data.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  // Not configured means there is no identity provider to ask — a developer
  // running the console on mocks. Gating there would make it unusable.
  if (status === "unconfigured" || status === "authenticated") return <>{children}</>;

  if (status === "restoring") {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <p className="text-sm text-muted-foreground">Checking your session…</p>
      </div>
    );
  }

  return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
}
